var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTelegram = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "1b",
    width: 26,
    height: 26,
    x: 3,
    y: 3,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M28.8 3.2H3.2v25.6h25.6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#1b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.05 5.393 3.866 14.365a.3.3 0 0 0-.04.019c-.188.106-1.5.909.35 1.628l.019.007 5.52 1.784a.305.305 0 0 0 .255-.032L23.662 9.23a.3.3 0 0 1 .11-.042c.19-.031.74-.09.392.35-.392.5-9.745 8.881-10.783 9.81a.315.315 0 0 0-.103.21l-.453 5.4a.354.354 0 0 0 .141.282.344.344 0 0 0 .409-.03l3.28-2.932a.306.306 0 0 1 .381-.02l5.723 4.155.018.013c.139.086 1.635.956 2.067-.988l3.95-18.782c.005-.06.059-.714-.409-1.1-.49-.404-1.186-.2-1.29-.178a.3.3 0 0 0-.045.016Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTelegram);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/telegram.926bbe631af0f23110907a697de3f4e5.svg";